goog.provide('el8.appanalytics.reports.mu');

goog.require('el8.appanalytics.dialog.viewMuNumDen');
goog.require('el8.appanalytics.ReportTab');
goog.require('el8.appanalytics.util');
goog.require('el8.data.currUser');
goog.require('el8.service.infoField');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.template.appanalytics.reports.mu');

el8.appanalytics.reports.mu.create = function() {

    var dateField = null;
    var displayedDate = null;
    var displayedPhysicianId = null;

    var measuresInfo = null;
    var allowKickoff = (el8Globals.SITE_PREFIX !== "app");

    var container = $('#mu-section');
    var that = new el8.appanalytics.ReportTab({
        trigger: $('.report-title[_section="mu"]'),
        container: container,
        formSpec: {
            container: $('form', container),
            buttonElt: $('.mu-report-buttons', container),
            fields: [
                {
                    name: 'endDate',
                    selector: ':input[name="endDate"]',
                    infoText: 'for 90 day report...',
                    datePickerOpts: {
                        // 6-hour offset to allow for nightly jobs to
                        // run after midnight
                        maxDate: el8.service.tz.nowPlusHours(6).zeroTime(),
                        minDate: el8.service.tz.newTzDate(2012, 8, 5)
                    }
                },
                {
                    name: 'period',
                    selector: ':input[name="period"]'
                },
                {
                    name: 'physicianId',
                    selector: ':input[name="physicianId"]'
                }
            ],
            buttons: (function() {
                var rv = [
                    ['update', 'Generate Report', function() { that.load(); }, true]
                ];
                if (allowKickoff) {
                    rv.push(
                        ['kickoff', 'TESTING: Kickoff Update', function() { that.kickoff(); }, false]
                    );
                }
                return rv;
            })()
        },
        initFn: function() {
            var today = el8.service.tz.today();
            var $physIdOptions = $('[name=physicianId] option');
            var availablePhysStaffIds = $.map($physIdOptions, function (o) { return parseInt(o.value); });
            var currentUserStaffId = el8.data.currUser.getStaffId();

            dateField = that._form.getField('endDate');
            dateField.setVal(today.asString());
            that._update_selection_ui_on_period_change();

            if (availablePhysStaffIds.includes(currentUserStaffId)) {
                that._form.setVal('physicianId', currentUserStaffId);
            } else {
                that._form.setVal('physicianId', availablePhysStaffIds[0]);
            }

            that._bindTriggers();

            el8React.renderSupportDialog('mu-react-support-dialog-container')
        },
        loadFn: function(callbackFn, onCompleteFn) {
            if (el8Globals.PASSPORT_EMR || el8Globals.TEST_ACCOUNT) {
                that._container.html(el8.template.appanalytics.reports.mu.placeholderReport());
                return;
            }

            $.el8_ajax({
                type: 'GET',
                url: that.get_mu_url(),
                success: function(data) {
                    displayedPhysicianId = that._form.getVal('physicianId');
                    displayedDate = el8.service.tz.newTzDate(that._form.getVal('endDate'));
                    data['period'] = that._form.getVal('period');

                    $('.report-contents', container).html(
                        el8.template.appanalytics.reports.mu.content(data)
                    );

                    var updatedAt = el8.service.tz.toTzDateTime(data['updated_at']);

                    $('#mu-report-updated-at').text("Reports last updated at "+updatedAt.asDateTimeString()+".");
                    if (callbackFn) { callbackFn(); }
                    measuresInfo = data;
                    that.initResultTabs();
                },
                error_override: function(data) {
                    $('.report-contents', container).html(
                        el8.template.appanalytics.reports.mu.content({
                            error: true,
                            end_date: dateField.getVal()
                        })
                    );

                    if (callbackFn) { callbackFn(); }
                },
                complete: function() {
                    if (onCompleteFn) { onCompleteFn(); }
                }
            });
        }
    });

    that.currently_selected_period = function() {
        return $('input[name=period]:checked', container).val();
    };

    that.get_mu_url = function() {
        /**
         Evaluates the current state of the UI and returns the appropriate
         URL for fetching the MU given what the user has configured.
        **/

        var period = that.currently_selected_period();
        var params = {
          physicianId: that._form.getVal('physicianId'),
          tin: that._form.getVal('tin'),
        };

        if (!params.physicianId && !params.tin) {
            return null;
        }

        var url = null;
        if (period === "NINETY_DAY" || period === "SEVEN_DAY") {
            params.period = period;
            params.endDate = that._form.getVal('endDate');

            url = el8.service.urls.get('mu_with_end_date', [params]);
        }
        else if (period === "QUARTERLY") {
            var rawValue = that._form.getVal('quarter');
            params.year = rawValue.split('-')[0];
            params.quarter = rawValue.split('-')[1];

            url = el8.service.urls.get('mu_quarterly', [params]);
        }
        else {  // "CALENDAR_YEAR"
            params.year = that._form.getVal('year');

            url  = el8.service.urls.get('mu_calendar_year', [params]);
        }

        return url;
    };

    that._update_selection_ui_on_period_change = function() {

        var newPeriod = that.currently_selected_period();

        $("#mu-quarters-section").hide();
        $("#mu-years-section").hide();
        $("#mu-end-date-section").hide();

        if (newPeriod === "NINETY_DAY" || newPeriod === "SEVEN_DAY") {
            $("#mu-end-date-section").show();
        }
        else if (newPeriod === "QUARTERLY") {
            $("#mu-quarters-section").show();
        }
        else if (newPeriod === "CALENDAR_YEAR") {
            $("#mu-years-section").show();
        }
    };

    that.initResultTabs = function() {
        //mu-results-tab-header
        var tabbedNav = new el8.uiwidget.TabbedNav();
        tabbedNav.init({wrapper: $('#mu-results-tab-header')});
        tabbedNav.addTab({
            title: 'MIPS Promoting Interoperability',
            name: 'mips-interoperability-measures',
            contentDiv: $('#mu-results-mips-interoperability-measures-section')
        });
        tabbedNav.addTab({
            title: 'Medicaid Promoting Interoperability',
            name: 'medicaid-interoperability-measures',
            contentDiv: $('#mu-results-medicaid-interoperability-measures-section')
        });
        tabbedNav.showTab('mips-interoperability-measures');
    };

    that._bindTriggers = function() {
        container.on('change', 'input.manual-checkbox',  function(e) {
            var report_tab = $(this).closest('.tab-section');
            var name = $(this).data('name');
            // Update styling
            var requiredBool = $('.required-bool[data-name="'+name+'"]', report_tab).text();
            var isChecked = $(this).is(':checked');
            if ((requiredBool.toLowerCase() === 'yes' && !isChecked) ||
                    (requiredBool.toLowerCase() === 'no' && isChecked)) {
                that._updateStyle(name, 'no');
            } else {
                that._updateStyle(name, 'yes');
            }
            // silently save to the backend
            $.el8_ajax({
                type: 'POST',
                url: "/reports/mu/"+that._form.getVal('physicianId')+"/measures/"+name,
                data: {measure: JSON.stringify({bool_value: isChecked})}
            });
        }).on('blur', 'input.manual-num',  function(e) {
            var name = $(this).data('name');
            var numerator = that._getValue($(this));
            // If numerator manual, then denominator is computed
            var denominator = that._getValue($('.computed-den[data-name="'+name+'"]', container));
            that._computePercent(name, numerator, denominator);

        }).on('blur', 'input.manual-den',  function(e) {
            var name = $(this).data('name');
            var denominator = that._getValue($(this));
            // If denominator manual, then numerator is computed
            var numerator = that._getValue($('.computed-num[data-name="'+name+'"]', container));
            that._computePercent(name, numerator, denominator);

        }).on('click', '.view-mu-numden-trigger',  function(e) {
            var name = $(this).data('name');
            var stageName = $(this).closest('.tab-section').data('name');
            var data = _.filter(
                measuresInfo[stageName].core_set_measures.concat(
                    measuresInfo[stageName].menu_set_measures || []
                ), function (info) { return info.name === name; });

            if (data.length === 0) {
                UIM && UIM.logError('Could not find mu data for trigger ' + name);
            }
            else if (data.length > 1) {
                UIM && UIM.logError('Multiple mu data entries found for trigger ' + name);
            }
            else {
                data = data[0];
            }

            var csvUrl = $(this).data('csv-url');
            // APP-8375: hide csv link if it would be empty
            if (data['num'] + data['den'] < 1) {
                csvUrl = null;
            }
            var title = data['title'] || data['set'].capitalize() + ' ' + data['number'];
            el8.appanalytics.dialog.viewMuNumDen.show({
                numUrl: $(this).data('num-metric-url'),
                denUrl: $(this).data('den-metric-url'),
                csvUrl: csvUrl,
                title: title,
                description: data['description']
            });
        }).on('change', ':input[name="period"]',  function(e) {
            that._update_selection_ui_on_period_change();
        });

        el8.appanalytics.util.initCollapsibleFilters(container);

    };

    that._computePercent = function(name, numerator, denominator) {

        if ((denominator === '') || (numerator === '')) {
            $('.computed-percent[data-name="'+name+'"]', container).text('?');
            // Update styling
            that._updateStyle(name, null);

        } else if (denominator === 0) {
            $('.computed-percent[data-name="'+name+'"]', container).text('--');
            // Update styling
            that._updateStyle(name, null);

        } else {
            var computedPercent = (numerator/denominator)*100;
            $('.computed-percent[data-name="'+name+'"]', container).text(computedPercent.toFixed(1)+'%');

            // Update styling
            var requiredPercent = $('.required-percent[data-name="'+name+'"]', container).text().replace('%', '')*1;
            if (computedPercent < requiredPercent) {
                that._updateStyle(name, 'no');
            } else {
                that._updateStyle(name, 'yes');
            }
        }
    };

    that._updateStyle = function(name, state) {
        var $row = $('tr[data-name="'+name+'"]', container);
        if (state === 'yes') {
            $('.measure-icon', $row).html(
                el8.template.appanalytics.reports.mu.checkGoodIcon());
        }
        else {
            $('.measure-icon', $row).empty();
        }
    };

    that._getValue = function($elt) {
        var val = $elt.is('input') ? $elt.val() : $elt.text();
        if (val === '') { return ''; }
        return val*1;
    };

    that.kickoff = function() {
        var b = $("button[name='kickoff']");
        b.text("OK Wait a while...");
        $.el8_ajax({
            type: 'GET',
            url: '/reports/mu/testrefresh/',
            success: function(data) {
                b.text("All Done!");
            }
        });
    };

    return that;
};
